export default __webpack_public_path__ + "static/media/hcm-logo.bf475da0.webp";